<template>
  <footer class="footer">
  <div class="content has-text-centered">
    <p>
      <strong>Project with Buefy</strong> by <a href="https://jgthms.com">Rafael Morais de Assis</a>.
    </p>
  </div>
</footer>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>

</style>
